(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-fh-grid]');
    const cards = [...root.querySelectorAll('[data-fh-card]')];
    const sort = root.querySelector('[data-fh-sort]');
    const count = root.querySelector('[data-fh-count]');
    const state = { type: 'all', size: '100', family: 'all' };
    const updateCard = (card, option) => {
      const available = option.dataset.available === 'true';
      card.querySelector('[data-fh-size]').value = option.value;
      card.querySelectorAll('[data-fh-link]').forEach(link => link.setAttribute('href', option.dataset.url));
      const imageLink = card.querySelector('.fh-card-art a');
      imageLink.setAttribute('aria-label', option.dataset.alt);
      const image = imageLink.querySelector('img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
        image.alt = option.dataset.alt;
      }
      card.querySelector('[data-fh-price]').textContent = option.dataset.money;
      card.querySelector('[data-fh-size-text]').textContent = `${state.size} ml`;
      const button = card.querySelector('[data-fh-button]');
      card.querySelector('[data-fh-button-label]').textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
      button.classList.toggle('fh-button-muted', !available);
      card.querySelector('[data-fh-stock-note]').hidden = available;
      card.dataset.price = option.dataset.price;
      card.dataset.available = String(available);
    };
    const apply = () => {
      let total = 0;
      cards.forEach(card => {
        const option = [...card.querySelector('[data-fh-size]').options].find(option => option.dataset.size === state.size);
        const match = option && (state.type === 'all' || card.dataset.type === state.type) && (state.family === 'all' || card.dataset.families.split(/\s+/).includes(state.family));
        card.hidden = !match;
        if (match) { updateCard(card, option); total++; }
      });
      [...cards].sort((a, b) => {
        const stock = Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true');
        if (stock) return stock;
        if (sort.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
        if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.order) - Number(b.dataset.order);
      }).forEach(card => grid.appendChild(card));
      root.querySelectorAll('[data-fh-group]').forEach(group => group.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === state[group.dataset.fhGroup]))));
      count.textContent = `${total} ${count.dataset.label} · ${state.size} ml`;
      root.querySelector('[data-fh-empty]').hidden = total > 0;
    };
    root.querySelector('[data-fh-filters]').hidden = false;
    root.querySelector('[data-fh-sort-wrap]').hidden = false;
    root.querySelectorAll('[data-fh-group]').forEach(group => group.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button) return;
      state[group.dataset.fhGroup] = button.dataset.value;
      apply();
    }));
    root.querySelector('[data-fh-reset]').addEventListener('click', () => {
      Object.assign(state, { type: 'all', size: '100', family: 'all' });
      sort.value = 'featured';
      apply();
    });
    sort.addEventListener('change', apply);
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      event.stopPropagation();
      const heading = target.querySelector('h2, h3');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({preventScroll:true}); }
      target.scrollIntoView({behavior:'instant',block:'start'});
    }, true);
    apply();
  };
  document.querySelectorAll('[data-fhp]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fhp]').forEach(init));
})();
